const state = {
  userInfo: {},
  lang: "en_us",
  sideBarList: null,
  sideBarListEN: null
};

export default state;
